import { render } from "./editpurchasereturn.vue?vue&type=template&id=2d1ab9ba&scoped=true"
import script from "./editpurchasereturn.vue?vue&type=script&lang=js"
export * from "./editpurchasereturn.vue?vue&type=script&lang=js"

import "./editpurchasereturn.vue?vue&type=style&index=0&id=2d1ab9ba&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1ab9ba"]])

export default __exports__